import { PlayerApi } from '../../communication/player-api/PlayerApi'
import { PlayerAchievementList } from '../../communication/PlayerApiProtocol.generated'
import { hasExpired, ReduxAction } from '../ReduxUtils'
import { ApplicationState, getStore } from '../Store'

export const REQUEST_ACHIEVEMENTS = 'REQUEST_ACHIEVEMENTS'
export const RECEIVE_ACHIEVEMENTS = 'RECEIVE_ACHIEVEMENTS'
export const ACHIEVEMENTS_ERROR = 'ACHIEVEMENTS_ERROR'
export const fetchAchievements = (forced?: boolean) => getStore().dispatch(_fetchAchievements(forced) as any)

function _fetchAchievements(force?: boolean) {
	return (dispatch, getState: () => ApplicationState) => {

		if (!hasExpired(force, getState().player.achievementState, 120)) {
			return
		}
		dispatch(requestAchievements())

		PlayerApi.requestAchievements(
			(achievements: PlayerAchievementList) => {
				dispatch(receiveAchievements(achievements))
			},
			() => {
				dispatch(achievementsError())
			},
		)
	}
}
/**
 * Achievements have been requested from the server
 */
function requestAchievements(): ReduxAction<{}> {
	return {
		type: REQUEST_ACHIEVEMENTS,
		payload: {},
		createdTime : Date.now(),
	}
}

function achievementsError(): ReduxAction<{}> {
	return {
		type: ACHIEVEMENTS_ERROR,
		payload: {},
		createdTime : Date.now(),
	}
}
/**
 * Achievement response have been received from the server
 */
function receiveAchievements(achievements: PlayerAchievementList): ReduxAction<PlayerAchievementList> {
	return {
		type: RECEIVE_ACHIEVEMENTS,
		payload: achievements,
		createdTime : Date.now(),
	}
}
